/*=========================================================================================
  File Name: moduleDashboardMutations.js
  Description: Dashboard Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_TOPPAGES(state, toppages) {
        state.toppages = toppages
    }
}

